import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-choice-footer',
  templateUrl: './choice-footer.component.html',
  styleUrls: ['./choice-footer.component.scss']
})
export class ChoiceFooterComponent implements OnInit {
  @Input() okDisabled: boolean;
  @Input() okText;
  @Input() cancelText;
  @Input() oneButton: any;
  @Output() whenCancel = new EventEmitter<any>();
  @Output() whenOk = new EventEmitter<any>();
  @Input() okIcon = 'checkmark-sharp';
  @Input() cancelIcon = 'chevron-back';
  constructor() { }

  ngOnInit() {
  }

  ok() {
    if (this.okDisabled) {
      return;
    }
    this.whenOk.emit();
  }
  cancel() {
    this.whenCancel.emit();
  }
}
